/**
 * Product Card Video Autoplay & Dots Controller
 * Handles preload="none" videos: loads on viewport entry, plays muted/looped.
 */
(function(){'use strict';

var SELECTOR='video.cpc-card-video,video.product-card__video';

function initVideo(v){
  if(v._vc)return;
  v._vc=1;

  // Force muted state — required for autoplay policy
  v.muted=true;
  v.defaultMuted=true;
  v.playsInline=true;
  v.volume=0;
  v.setAttribute('muted','');
  v.setAttribute('playsinline','');

  function play(){
    if(!v.paused)return;
    // With preload="none", we need to load first
    if(v.preload==='none'&&v.readyState===0){
      v.load();
    }
    var p=v.play();
    if(p&&p.catch)p.catch(function(){});
  }

  // If video already has data buffered, play immediately
  if(v.readyState>=3) play();

  // Use IntersectionObserver: load+play when visible, pause+reset when off-screen
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          play();
        } else {
          if(!v.paused) v.pause();
        }
      });
    },{threshold:0.1,rootMargin:'150px 0px'});
    obs.observe(v);
  } else {
    // Fallback for old browsers: load and play directly
    play();
  }
}

function initDots(dots){
  if(dots._d)return;
  dots._d=1;
  var wrap=dots.closest('.cpc-img-wrap');
  if(!wrap)return;
  var slider=wrap.querySelector('.cpc-img-slider');
  if(!slider)return;
  var items=dots.querySelectorAll('.cpc-dot');
  if(!items.length)return;
  slider.addEventListener('scroll',function(){
    var idx=Math.round(slider.scrollLeft/slider.offsetWidth);
    items.forEach(function(d,i){d.classList.toggle('active',i===idx);});
  },{passive:true});
}

function initAll(){
  document.querySelectorAll(SELECTOR).forEach(initVideo);
  document.querySelectorAll('.cpc-img-dots').forEach(initDots);
}

// Run on DOM ready
if(document.readyState==='loading')
  document.addEventListener('DOMContentLoaded',initAll);
else
  initAll();

// Re-init after AJAX mutations (filters, infinite scroll, quick-view)
var raf=false;
new MutationObserver(function(){
  if(raf)return;raf=true;
  requestAnimationFrame(function(){initAll();raf=false;});
}).observe(document.body,{childList:true,subtree:true});

// iOS Safari: unlock autoplay on first user gesture
var touched=false;
document.addEventListener('touchstart',function(){
  if(touched)return;touched=true;
  document.querySelectorAll(SELECTOR).forEach(function(v){
    v.muted=true;
    if(v.readyState===0) v.load();
    if(v.paused){var p=v.play();if(p&&p.catch)p.catch(function(){});}
  });
},{passive:true});

// Resume all videos when tab becomes visible again
document.addEventListener('visibilitychange',function(){
  if(document.hidden)return;
  document.querySelectorAll(SELECTOR).forEach(function(v){
    v.muted=true;
    if(v.paused){
      if(v.readyState===0) v.load();
      var p=v.play();if(p&&p.catch)p.catch(function(){});
    }
  });
});

})();
